import React from "react";
import LinkBox from "./linkbox/Linkbox";
import Breadcrumbs from "../breadcrumbs/Breadcrumbs";
import SecondaryNavMob from "../secondary-nav-mob/SecondaryNavMob";
import SocialShare from "../social-share/SocialShare";

const Heading = props => {
  const data = props.Data || { type: "none", heading: "" };

  return (
    <section id="heading">
      <Breadcrumbs breadcrumbsData={props.breadcrumbsData} />
      {document.querySelector("#social-share-react") && (
        <SocialShare type="mobile" />
      )}
      {props.secondaryNavMobData &&
        props.secondaryNavMobData.active != false && (
          <SecondaryNavMob data={props.secondaryNavMobData} />
        )}
      <div className="container">
        <div className="row">
          <div className="col-12 col-md-6  order-2 order-md-1 main-heading">
            <h1>{data.heading}</h1>
            {data.description && <p>{data.description}</p>}
          </div>

          {/*Iteration 1 - Image*/}
          {data.type == "image" && (
            <div className="col-sm col-md-6 image order-1 order-md-2 ">
              <div
                id="homepage-banner-image"
                style={{ backgroundImage: "url(" + data.image + ")" }}
              >
                <div className="image-rectangle"></div>
                <div
                  className="caption"
                  dangerouslySetInnerHTML={{ __html: data.caption }}
                />
              </div>
            </div>
          )}

          {/*Iteration 2 - Linkbox*/}
          {data.type == "linkbox" && data.linkBox && (
            <div className="col-sm col-md-6 image order-2">
              <LinkBox Data={data.linkBox} view={"desktop"} />

              {data.linkBox.quickLinks && (
                <LinkBox Data={data.linkBox} view={"mobile"} />
              )}
            </div>
          )}

          {/*Iteration none - Fallback*/}
          {data.type == "none" && (
            <div className="col-sm col-md-6 image order-2">&nbsp;</div>
          )}
        </div>
      </div>
    </section>
  );
};

export default Heading;
